import { useEffect, useRef, useState, useMemo } from "react";
import Panzoom from "@panzoom/panzoom";
import { useClientLayout } from "../../../../hooks";
import Bicycle from "../bicycle";
import "./index.scss";
import { tabColors, bubbleEnum } from "../../../../constants";
import thumbMapImage from "@/assets/img/thumb-map.png";

import mapImage from "@/assets/img/map.png";

import thumbCompassImage from "@/assets/img/thumb-compass.png";

import plusScale from "@/assets/img/plusScale.png";
import reduceScale from "@/assets/img/reduceScale.png";
import selectPosition from "@/assets/img/position.png";
import { useContextData } from "../../data-context";

import {
  SchoolBubble,
  NeighborhoodBubble,
  BusinessBubble,
  ParkBubble,
  PublicBubble,
  TownBubble,
  Bubble,
  Position,
} from "../../components";

interface IProps {
  style?: React.CSSProperties;
  classNames?: string;
  tab: number;
  rectWidth: number;
  initScale: number;
  isPC: boolean;
  bubbles: any;
  onSelected?: (data: any) => void;
}

const Map = (props: IProps) => {
  const { tab, classNames, style, rectWidth, initScale, isPC, bubbles, onSelected } = props;
  const timer = useRef<any>();
  const mapRef = useRef<any>();
  const thumbMapRef = useRef<any>();
  const mapPanzoom = useRef<any>();
  const initRectPosition = useRef<any>();
  const ratio = useRef<{ ratioX: number; ratioY: number }>({
    ratioX: 0,
    ratioY: 0,
  });

  const isPanzoomMap = useRef<boolean>(false);
  const isPanzoomThumbMap = useRef<boolean>(false);
  const thumbMapPanzoom = useRef<any>();

  const [scale, setScale] = useState(initScale);
  const [loaded, setLoaded] = useState(false);
  const [rectPosition, setRectPosition] = useState({ x: -10000, y: -10000 });

  const {
    contextData: { selectAddress },
  } = useContextData();

  const {
    targetRef: targetMapRef,
    width: mapWidth,
    height: mapHeight,
  } = useClientLayout();
  const {
    targetRef: targetImageRef,
    onLoad,
    width: mapImageWidth,
    height: mapImageHeight,
  } = useClientLayout({ useLoad: true });

  const {
    targetRef: targetThumbMapRef,
    width: thumbMapWidth,
    height: thumbMapHeight,
  } = useClientLayout();
  const {
    targetRef: thumbMapImageRef,
    width: thumbMapImageWidth,
    height: thumbMapImageHeight,
    onLoad: onLoadThumbMapImage,
  } = useClientLayout({ useLoad: true });
  const markScale = 1 / scale;
  const WHRatio = useMemo(() => {
    if (!mapImageWidth || !mapImageHeight) {
      return 6284 / 4024;
    }
    return mapImageWidth / mapImageHeight;
  }, [mapImageWidth, mapImageHeight]); // 6284 / 4024;

  const mapPaddingVertical = useMemo(() => {
    if (mapHeight <= mapImageHeight || !mapHeight || !mapImageHeight) {
      return "0";
    }

    return `${(mapHeight - mapImageHeight) / 2}px 0`;
  }, [mapHeight, mapImageHeight]);

  const onWheelMap = (event: any) => {
    mapPanzoom.current.zoomWithWheel(event);
    isPanzoomMap.current = true;
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      isPanzoomMap.current = false;
    }, 10);
  };

  const onPanzoomChange = (event: any) => {
    if (!isPanzoomMap.current) return;
    const { scale: curScale, x, y } = event?.detail || {};
    setScale(curScale);
    if (initRectPosition.current) {
      const ratioX = x / mapImageWidth;
      const ratioY = y / mapImageHeight;
      ratio.current = { ratioX, ratioY };
      const curRectPosition = {
        x: initRectPosition.current.x - thumbMapImageWidth * ratioX,
        y: initRectPosition.current.y - thumbMapImageHeight * ratioY,
      };

      setRectPosition(curRectPosition);
      thumbMapPanzoom.current.pan(
        thumbMapImageWidth * ratioX,
        thumbMapImageHeight * ratioY
      );
    }
  };

  const onPanzoomThumbChange = (event: any) => {
    if (!isPanzoomThumbMap.current) return;
    const { x, y } = event?.detail || {};
    if (initRectPosition.current) {
      const ratioX = x / thumbMapImageWidth;
      const ratioY = y / thumbMapImageHeight;
      ratio.current = { ratioX, ratioY };
      const curRectPosition = {
        x: initRectPosition.current.x - thumbMapImageWidth * ratioX,
        y: initRectPosition.current.y - thumbMapImageHeight * ratioY,
      };
      setRectPosition(curRectPosition);
      mapPanzoom.current.pan(mapImageWidth * ratioX, mapImageHeight * ratioY);
    }
  };

  const onPanzoomThumbStart = () => {
    isPanzoomThumbMap.current = true;
  };

  const onPanzoomThumbEnd = () => {
    isPanzoomThumbMap.current = false;
  };

  const onPanzoomStart = (event: any) => {
    isPanzoomMap.current = true;
  };

  const onPanzoomEnd = () => {
    isPanzoomMap.current = false;
  };

  const onLoadMapImg = () => {
    setLoaded(true);
    onLoad();
  };

  useEffect(() => {
    console.log(
      "==========>矩形初始位置:",
      thumbMapImageWidth,
      thumbMapImageHeight
    );
    if (!thumbMapImageWidth || !thumbMapImageHeight) return;
    const { ratioX, ratioY } = ratio.current;
    initRectPosition.current = {
      x: (thumbMapImageWidth - rectWidth * markScale) / 2,
      y: (thumbMapImageHeight - (1 / WHRatio) * rectWidth * markScale) / 2,
    };
    const curRectPosition = {
      x: initRectPosition.current.x - thumbMapImageWidth * ratioX,
      y: initRectPosition.current.y - thumbMapImageHeight * ratioY,
    };
    setRectPosition(curRectPosition);
  }, [markScale, thumbMapImageWidth, thumbMapImageHeight, WHRatio]);

  // 小地图
  useEffect(() => {
    if (!thumbMapRef.current) return;
    thumbMapPanzoom.current = Panzoom(thumbMapRef.current, {
      // animate: true,
      disableZoom: true,
    });

    thumbMapRef.current.parentElement.addEventListener(
      "wheel",
      thumbMapPanzoom.current.zoomWithWheel
    );
    thumbMapRef.current.addEventListener("panzoomchange", onPanzoomThumbChange);
    thumbMapRef.current.addEventListener("panzoomstart", onPanzoomThumbStart);
    thumbMapRef.current.addEventListener("panzoomend", onPanzoomThumbEnd);
    return () => {
      thumbMapPanzoom.current?.destroy();
      thumbMapRef.current?.removeEventListener(
        "panzoomchange",
        onPanzoomThumbChange
      );
      thumbMapRef.current?.removeEventListener(
        "panzoomstart",
        onPanzoomThumbStart
      );
      thumbMapRef.current?.removeEventListener("panzoomend", onPanzoomThumbEnd);
      thumbMapRef.current?.parentElement?.removeEventListener(
        "wheel",
        thumbMapPanzoom.current.zoomWithWheel
      );
    };
  }, [thumbMapWidth, thumbMapHeight, thumbMapImageWidth, thumbMapImageHeight]); // 依赖用于更新useEffect中的代码

  // 大地图
  useEffect(() => {
    if (!mapRef.current) return;
    mapPanzoom.current = Panzoom(mapRef.current, {
      minScale: 1,
      maxScale: isPC ? initScale + 7 : initScale + 10,
      step: 1,
      // animate: true,
      // canvas: true,
    });
    mapPanzoom.current.zoom(initScale);
    mapRef.current.parentElement.addEventListener("wheel", onWheelMap);
    mapRef.current.addEventListener("panzoomchange", onPanzoomChange);
    mapRef.current.addEventListener("panzoomstart", onPanzoomStart);
    mapRef.current.addEventListener("panzoomend", onPanzoomEnd);
    return () => {
      mapPanzoom.current?.destroy();
      mapRef.current?.removeEventListener("panzoomchange", onPanzoomChange);
      mapRef.current?.removeEventListener("panzoomstart", onPanzoomStart);
      mapRef.current?.removeEventListener("panzoomend", onPanzoomEnd);
      mapRef.current?.parentElement?.removeEventListener("wheel", onWheelMap);
    };
  }, [mapImageWidth, mapImageHeight, mapWidth, mapHeight, initScale, isPC]); // 依赖用于更新useEffect中的代码

  const onPlusScale = () => {
    mapPanzoom.current.zoomIn({ step: 1, animate: true });
    setScale(mapPanzoom.current.getScale());
  };
  const onReduceScale = () => {
    mapPanzoom.current.zoomOut({ step: 1, animate: true });
    setScale(mapPanzoom.current.getScale());
  };

  const curPosition = useMemo(() => {
    const { bar_left, bar_top } = selectAddress || {};
    if (tab === 5 || !bar_top || !bar_left) return;
    return  <Position
      markScale={markScale}
      isPC={isPC}
      name={selectAddress.name}
      style={{
        left: `${bar_left}%`,
        top: `${bar_top}%`,
        transform: `scale(${markScale})`,
      }}
    />
  }, [tab, selectAddress, markScale, isPC]);

  return (
    <div className={`mapContainer ${classNames}`} style={style}>
      <div
        className="thumbMapContainer"
        style={{ top: isPC ? "1rem" : "5rem" }}
      >
        <div
          className="scaleWrap"
          style={{ marginRight: isPC ? "1.25rem" : "0.625rem" }}
        >
          <div
            className="plusScale"
            onClick={onPlusScale}
            style={{
              width: isPC ? "3.125rem" : "1.5rem",
              height: isPC ? "2.9375rem" : "1.5rem",
            }}
          >
            <img
              src={plusScale}
              style={{ width: isPC ? "1rem" : "1rem" }}
              alt=""
            />
          </div>
          <div
            className="reduceScale"
            onClick={onReduceScale}
            style={{
              width: isPC ? "3.125rem" : "1.5rem",
              height: isPC ? "2.9375rem" : "1.5rem",
            }}
          >
            <img
              src={reduceScale}
              alt=""
              style={{ width: isPC ? "1rem" : "1rem" }}
            />
          </div>
        </div>
        <div
          className="thumbMapWrap"
          style={{
            width: isPC ? "13.8125rem" : "7.5rem",
            height: isPC ? "13.8125rem" : "7.5rem",
          }}
        >
          <div className="thumbMap" ref={targetThumbMapRef}>
            {isPC && (
              <img
                className="thumbCompassImage"
                src={thumbCompassImage}
                alt=""
              />
            )}
            <div
              className="thumbMapContent"
              ref={thumbMapRef}
              style={{ width: "316px", height: `${(1 / WHRatio) * 316}px` }}
            >
              <div
                className="rect"
                style={{
                  left: `${rectPosition.x}px`,
                  top: `${rectPosition.y}px`,
                  width: `${rectWidth * markScale}px`,
                  height: `${(1 / WHRatio) * rectWidth * markScale}px`,
                }}
              ></div>
              <img
                className="thumbMapImage"
                src={thumbMapImage}
                ref={thumbMapImageRef}
                style={{ width: "316px", height: `${(1 / WHRatio) * 316}px` }}
                onLoad={onLoadThumbMapImage}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="map"
        ref={targetMapRef}
        style={{ padding: mapPaddingVertical }}
      >
        <div className="mapContent" ref={mapRef}>
          {/* <Bicycle /> */}
          <img
            src={mapImage}
            className="mapImg"
            alt=""
            ref={targetImageRef}
            onLoad={onLoadMapImg}
          />

          {curPosition}
          {bubbles.map((item: any, index: number) => {
            const { bar_lat: selectLat, bar_lon: selectLon } = selectAddress || {};
            return selectLat === item.bar_lat && selectLon === item.bar_lon ? (
              <Position
                key={index}
                markScale={markScale}
                isPC={isPC}
                name={selectAddress.name}
                style={{
                  left: `${item.bar_left}%`,
                  top: `${item.bar_top}%`,
                  transform: `scale(${markScale})`,
                }}
              />
            ) : (
              <Bubble
                key={index}
                {...props}
                left={bubbleEnum[tab].left}
                middle={bubbleEnum[tab].middle}
                right={bubbleEnum[tab].right}
                markColor={tabColors[tab]}
                text={item.name}
                id={item.id}
                markScale={markScale}
                marks={item.tubiao.split(",")}
                bubblesNumer={bubbles.length}
                style={{
                  left: `${item.bar_left}%`,
                  top: `${item.bar_top}%`,
                  transform: `scale(${markScale})`,
                }}
                onClick={() => onSelected?.(item.id)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Map;
